/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    CAMPAIGNS: 'Εκστρατείες',
    CERTIFICATES: 'Πιστοποιητικά',
    CHALLENGES: 'Προκλήσεις',
    CHAT: 'Συνομιλία',
    CLOSE: 'Κλείστε το',
    CLUB: 'Λέσχη',
    COMMISSIONED_PRODUCTS: 'Προϊόντα κατά παραγγελία',
    COMMUNICATIONS: 'Επικοινωνίες',
    CONFIRM: 'Επιβεβαίωση',
    COUNTERPART: 'Αντίπαλοι',
    DASHBOARD: 'Πίνακας ελέγχου',
    DESIGN_REQUESTS: 'Αιτήσεις σχεδιασμού',
    DETAILS: 'Γενικές πληροφορίες',
    EXTERNAL_APPLICATIONS: 'Εξωτερικές εφαρμογές',
    FOLLOWER_MESSAGES: 'Μηνύματα Followers',
    GENERICS: 'Γενικές',
    LINKS: 'Σύνδεσμοι',
    LIVE: 'Άμεση',
    LOGOUT: 'Έξοδος',
    MEMBERS: 'Συνεργάτες',
    MENTIONS: 'Αναφορές',
    OFFERS: 'Προσφορές',
    ON_DEMAND_CAMPAIGNS: 'Καμπάνιες κατά παραγγελία',
    OPPORTUNITIES: 'Ευκαιρίες',
    ORDERS: 'Πληρωμένες παραγγελίες',
    PARTNERS: 'Εταίροι',
    PERSONAL_AREA: 'Προσωπική περιοχή',
    PRODUCTS_OFFERED: 'Προσφερόμενα προϊόντα',
    PROFILE: 'Προφίλ',
    PROZIS_COMMUNITY: 'Κοινότητα Prozis',
    QUESTIONS: 'Ερωτήσεις',
    REMUNERATIONS: 'Αποδοχές',
    SELECT_LANGUAGE: 'Επιλέξτε γλώσσα',
    SELECT_PARTNER: 'Επιλέξτε άλλον εταίρο',
    SERVICES: 'Υπηρεσίες',
    SOCIAL_NETWORK: 'Κοινωνικό δίκτυο Prozis',
    STATISTICS: 'Στατιστικά στοιχεία',
    VIDEO_TUTORIALS: 'Βίντεο tutorials'
  },
  ERROR: {
    ERROR: 'Σφάλμα',
    FETCH_DATA: 'Λήψη δεδομένων'
  },
  HEADER: {},
  LABEL: {
    CAMPAIGNS: 'Εκστρατείες',
    CHALLENGES: 'Προκλήσεις',
    CHAT: 'Συνομιλία',
    COMMUNICATIONS: 'Επικοινωνίες',
    COUNTERPARTS: 'Αντίπαλοι',
    DASHBOARD: 'Πίνακας ελέγχου',
    DESIGN_REQUESTS: 'Αιτήσεις σχεδιασμού',
    DETAILS: 'Λεπτομέρειες',
    EXTERNAL_APPLICATIONS: 'Εξωτερικές εφαρμογές',
    FILTER: 'Φίλτρο',
    FILTERED: 'Φιλτραρισμένο',
    FOLLOWER_MESSAGES: 'Μηνύματα Followers',
    GENERICS: 'Γενικές',
    HOME: 'Πίσω',
    LINKS: 'Σύνδεσμοι',
    LOGOUT: 'Έξοδος',
    MEMBERS: 'Συνεργάτες',
    MENTIONS: 'Αναφορές στο Instagram',
    NOT_FOUND: '404, Έχετε χαθεί;',
    OFFERS: 'Προσφορές',
    ORDERS: 'Παραγγελία',
    PARTNERSHIP_NOT_FOUND: 'Δεν βρέθηκε συνεργάτης.',
    PENDING_COUNTERPART:
      'Εκκρεμείς αντισυμβαλλόμενοι από την προηγούμενη περίοδο',
    PENDING_COUNTERPART_CURRENT:
      'Εκκρεμείς αντισυμβαλλόμενοι για τον τρέχοντα μήνα',
    PENDING_REMUNERATION: 'Αμοιβές που εκκρεμούν από την προηγούμενη περίοδο',
    PENDING_REMUNERATION_CURRENT: 'Εκκρεμείς πληρωμές για τον τρέχοντα μήνα',
    PERSONAL_AREA: 'Προσωπική περιοχή',
    PRODUCTS: 'Προϊόντα',
    REMUNERATIONS: 'Αποδοχές',
    SEARCH_PARTNERSHIP: 'Ψάχνω για συνεργάτη',
    SELECT_LANGUAGE: 'Επιλέξτε γλώσσα',
    SELECT_PARTNERSHIP: 'Επιλέξτε έναν εταίρο',
    UNAUTHROZIED: '403, Μη εξουσιοδοτημένη πρόσβαση!!!'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
